import nt, { createContext as Bt, useRef as $, useEffect as O, useMemo as ot, useLayoutEffect as Yt, useState as H, forwardRef as it, useContext as Ut, useCallback as Vt } from "react";
import { createPortal as zt } from "react-dom";
const Ht = typeof window < "u", qt = "2.5.1";
function Gt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var at = { exports: {} }, _ = at.exports = {}, L, k;
function Re() {
  throw new Error("setTimeout has not been defined");
}
function Te() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? L = setTimeout : L = Re;
  } catch {
    L = Re;
  }
  try {
    typeof clearTimeout == "function" ? k = clearTimeout : k = Te;
  } catch {
    k = Te;
  }
})();
function st(t) {
  if (L === setTimeout)
    return setTimeout(t, 0);
  if ((L === Re || !L) && setTimeout)
    return L = setTimeout, setTimeout(t, 0);
  try {
    return L(t, 0);
  } catch {
    try {
      return L.call(null, t, 0);
    } catch {
      return L.call(this, t, 0);
    }
  }
}
function Jt(t) {
  if (k === clearTimeout)
    return clearTimeout(t);
  if ((k === Te || !k) && clearTimeout)
    return k = clearTimeout, clearTimeout(t);
  try {
    return k(t);
  } catch {
    try {
      return k.call(null, t);
    } catch {
      return k.call(this, t);
    }
  }
}
var M = [], K = !1, z, de = -1;
function Xt() {
  !K || !z || (K = !1, z.length ? M = z.concat(M) : de = -1, M.length && ut());
}
function ut() {
  if (!K) {
    var t = st(Xt);
    K = !0;
    for (var n = M.length; n; ) {
      for (z = M, M = []; ++de < n; )
        z && z[de].run();
      de = -1, n = M.length;
    }
    z = null, K = !1, Jt(t);
  }
}
_.nextTick = function(t) {
  var n = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
  M.push(new ct(t, n)), M.length === 1 && !K && st(ut);
};
function ct(t, n) {
  this.fun = t, this.array = n;
}
ct.prototype.run = function() {
  this.fun.apply(null, this.array);
};
_.title = "browser";
_.browser = !0;
_.env = {};
_.argv = [];
_.version = "";
_.versions = {};
function N() {
}
_.on = N;
_.addListener = N;
_.once = N;
_.off = N;
_.removeListener = N;
_.removeAllListeners = N;
_.emit = N;
_.prependListener = N;
_.prependOnceListener = N;
_.listeners = function(t) {
  return [];
};
_.binding = function(t) {
  throw new Error("process.binding is not supported");
};
_.cwd = function() {
  return "/";
};
_.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
_.umask = function() {
  return 0;
};
var Kt = at.exports;
const lt = /* @__PURE__ */ Gt(Kt);
var fe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Qt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ce = { exports: {} }, oe = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ke;
function Zt() {
  if (Ke)
    return oe;
  Ke = 1;
  var t = nt, n = Symbol.for("react.element"), i = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, d, m) {
    var g, R = {}, C = null, x = null;
    m !== void 0 && (C = "" + m), d.key !== void 0 && (C = "" + d.key), d.ref !== void 0 && (x = d.ref);
    for (g in d)
      o.call(d, g) && !c.hasOwnProperty(g) && (R[g] = d[g]);
    if (u && u.defaultProps)
      for (g in d = u.defaultProps, d)
        R[g] === void 0 && (R[g] = d[g]);
    return { $$typeof: n, type: u, key: C, ref: x, props: R, _owner: s.current };
  }
  return oe.Fragment = i, oe.jsx = l, oe.jsxs = l, oe;
}
var ie = {}, Qe;
function er() {
  return Qe || (Qe = 1, lt.env.NODE_ENV !== "production" && function() {
    var t = nt, n = Symbol.for("react.element"), i = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), R = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), Y = Symbol.iterator, A = "@@iterator";
    function B(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = Y && e[Y] || e[A];
      return typeof r == "function" ? r : null;
    }
    var P = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(e) {
      {
        for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), f = 1; f < r; f++)
          a[f - 1] = arguments[f];
        Z("error", e, a);
      }
    }
    function Z(e, r, a) {
      {
        var f = P.ReactDebugCurrentFrame, p = f.getStackAddendum();
        p !== "" && (r += "%s", a = a.concat([p]));
        var b = a.map(function(h) {
          return String(h);
        });
        b.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, b);
      }
    }
    var ee = !1, q = !1, E = !1, I = !1, U = !1, te;
    te = Symbol.for("react.module.reference");
    function ht(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === o || e === c || U || e === s || e === m || e === g || I || e === x || ee || q || E || typeof e == "object" && e !== null && (e.$$typeof === C || e.$$typeof === R || e.$$typeof === l || e.$$typeof === u || e.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === te || e.getModuleId !== void 0));
    }
    function pt(e, r, a) {
      var f = e.displayName;
      if (f)
        return f;
      var p = r.displayName || r.name || "";
      return p !== "" ? a + "(" + p + ")" : a;
    }
    function xe(e) {
      return e.displayName || "Context";
    }
    function W(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case o:
          return "Fragment";
        case i:
          return "Portal";
        case c:
          return "Profiler";
        case s:
          return "StrictMode";
        case m:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case u:
            var r = e;
            return xe(r) + ".Consumer";
          case l:
            var a = e;
            return xe(a._context) + ".Provider";
          case d:
            return pt(e, e.render, "ForwardRef");
          case R:
            var f = e.displayName || null;
            return f !== null ? f : W(e.type) || "Memo";
          case C: {
            var p = e, b = p._payload, h = p._init;
            try {
              return W(h(b));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var V = Object.assign, re = 0, Pe, je, De, Ie, Le, ke, Ae;
    function We() {
    }
    We.__reactDisabledLog = !0;
    function gt() {
      {
        if (re === 0) {
          Pe = console.log, je = console.info, De = console.warn, Ie = console.error, Le = console.group, ke = console.groupCollapsed, Ae = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: We,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        re++;
      }
    }
    function mt() {
      {
        if (re--, re === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: V({}, e, {
              value: Pe
            }),
            info: V({}, e, {
              value: je
            }),
            warn: V({}, e, {
              value: De
            }),
            error: V({}, e, {
              value: Ie
            }),
            group: V({}, e, {
              value: Le
            }),
            groupCollapsed: V({}, e, {
              value: ke
            }),
            groupEnd: V({}, e, {
              value: Ae
            })
          });
        }
        re < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var he = P.ReactCurrentDispatcher, pe;
    function ae(e, r, a) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (p) {
            var f = p.stack.trim().match(/\n( *(at )?)/);
            pe = f && f[1] || "";
          }
        return `
` + pe + e;
      }
    }
    var ge = !1, se;
    {
      var bt = typeof WeakMap == "function" ? WeakMap : Map;
      se = new bt();
    }
    function Fe(e, r) {
      if (!e || ge)
        return "";
      {
        var a = se.get(e);
        if (a !== void 0)
          return a;
      }
      var f;
      ge = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = he.current, he.current = null, gt();
      try {
        if (r) {
          var h = function() {
            throw Error();
          };
          if (Object.defineProperty(h.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(h, []);
            } catch (F) {
              f = F;
            }
            Reflect.construct(e, [], h);
          } else {
            try {
              h.call();
            } catch (F) {
              f = F;
            }
            e.call(h.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (F) {
            f = F;
          }
          e();
        }
      } catch (F) {
        if (F && f && typeof F.stack == "string") {
          for (var v = F.stack.split(`
`), S = f.stack.split(`
`), w = v.length - 1, T = S.length - 1; w >= 1 && T >= 0 && v[w] !== S[T]; )
            T--;
          for (; w >= 1 && T >= 0; w--, T--)
            if (v[w] !== S[T]) {
              if (w !== 1 || T !== 1)
                do
                  if (w--, T--, T < 0 || v[w] !== S[T]) {
                    var j = `
` + v[w].replace(" at new ", " at ");
                    return e.displayName && j.includes("<anonymous>") && (j = j.replace("<anonymous>", e.displayName)), typeof e == "function" && se.set(e, j), j;
                  }
                while (w >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        ge = !1, he.current = b, mt(), Error.prepareStackTrace = p;
      }
      var J = e ? e.displayName || e.name : "", Xe = J ? ae(J) : "";
      return typeof e == "function" && se.set(e, Xe), Xe;
    }
    function yt(e, r, a) {
      return Fe(e, !1);
    }
    function Et(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function ue(e, r, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Fe(e, Et(e));
      if (typeof e == "string")
        return ae(e);
      switch (e) {
        case m:
          return ae("Suspense");
        case g:
          return ae("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case d:
            return yt(e.render);
          case R:
            return ue(e.type, r, a);
          case C: {
            var f = e, p = f._payload, b = f._init;
            try {
              return ue(b(p), r, a);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Me = {}, $e = P.ReactDebugCurrentFrame;
    function le(e) {
      if (e) {
        var r = e._owner, a = ue(e.type, e._source, r ? r.type : null);
        $e.setExtraStackFrame(a);
      } else
        $e.setExtraStackFrame(null);
    }
    function wt(e, r, a, f, p) {
      {
        var b = Function.call.bind(ce);
        for (var h in e)
          if (b(e, h)) {
            var v = void 0;
            try {
              if (typeof e[h] != "function") {
                var S = Error((f || "React class") + ": " + a + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw S.name = "Invariant Violation", S;
              }
              v = e[h](r, h, f, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (w) {
              v = w;
            }
            v && !(v instanceof Error) && (le(p), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", a, h, typeof v), le(null)), v instanceof Error && !(v.message in Me) && (Me[v.message] = !0, le(p), y("Failed %s type: %s", a, v.message), le(null));
          }
      }
    }
    var _t = Array.isArray;
    function me(e) {
      return _t(e);
    }
    function Rt(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, a = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function Tt(e) {
      try {
        return Ne(e), !1;
      } catch {
        return !0;
      }
    }
    function Ne(e) {
      return "" + e;
    }
    function Be(e) {
      if (Tt(e))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rt(e)), Ne(e);
    }
    var ne = P.ReactCurrentOwner, Ct = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ye, Ue, be;
    be = {};
    function St(e) {
      if (ce.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Ot(e) {
      if (ce.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function xt(e, r) {
      if (typeof e.ref == "string" && ne.current && r && ne.current.stateNode !== r) {
        var a = W(ne.current.type);
        be[a] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', W(ne.current.type), e.ref), be[a] = !0);
      }
    }
    function Pt(e, r) {
      {
        var a = function() {
          Ye || (Ye = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: a,
          configurable: !0
        });
      }
    }
    function jt(e, r) {
      {
        var a = function() {
          Ue || (Ue = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: a,
          configurable: !0
        });
      }
    }
    var Dt = function(e, r, a, f, p, b, h) {
      var v = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: a,
        props: h,
        // Record the component responsible for creating this element.
        _owner: b
      };
      return v._store = {}, Object.defineProperty(v._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(v, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.defineProperty(v, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: p
      }), Object.freeze && (Object.freeze(v.props), Object.freeze(v)), v;
    };
    function It(e, r, a, f, p) {
      {
        var b, h = {}, v = null, S = null;
        a !== void 0 && (Be(a), v = "" + a), Ot(r) && (Be(r.key), v = "" + r.key), St(r) && (S = r.ref, xt(r, p));
        for (b in r)
          ce.call(r, b) && !Ct.hasOwnProperty(b) && (h[b] = r[b]);
        if (e && e.defaultProps) {
          var w = e.defaultProps;
          for (b in w)
            h[b] === void 0 && (h[b] = w[b]);
        }
        if (v || S) {
          var T = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          v && Pt(h, T), S && jt(h, T);
        }
        return Dt(e, v, S, p, f, ne.current, h);
      }
    }
    var ye = P.ReactCurrentOwner, Ve = P.ReactDebugCurrentFrame;
    function G(e) {
      if (e) {
        var r = e._owner, a = ue(e.type, e._source, r ? r.type : null);
        Ve.setExtraStackFrame(a);
      } else
        Ve.setExtraStackFrame(null);
    }
    var Ee;
    Ee = !1;
    function we(e) {
      return typeof e == "object" && e !== null && e.$$typeof === n;
    }
    function ze() {
      {
        if (ye.current) {
          var e = W(ye.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Lt(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), a = e.lineNumber;
          return `

Check your code at ` + r + ":" + a + ".";
        }
        return "";
      }
    }
    var He = {};
    function kt(e) {
      {
        var r = ze();
        if (!r) {
          var a = typeof e == "string" ? e : e.displayName || e.name;
          a && (r = `

Check the top-level render call using <` + a + ">.");
        }
        return r;
      }
    }
    function qe(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var a = kt(r);
        if (He[a])
          return;
        He[a] = !0;
        var f = "";
        e && e._owner && e._owner !== ye.current && (f = " It was passed a child from " + W(e._owner.type) + "."), G(e), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', a, f), G(null);
      }
    }
    function Ge(e, r) {
      {
        if (typeof e != "object")
          return;
        if (me(e))
          for (var a = 0; a < e.length; a++) {
            var f = e[a];
            we(f) && qe(f, r);
          }
        else if (we(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var p = B(e);
          if (typeof p == "function" && p !== e.entries)
            for (var b = p.call(e), h; !(h = b.next()).done; )
              we(h.value) && qe(h.value, r);
        }
      }
    }
    function At(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var a;
        if (typeof r == "function")
          a = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === R))
          a = r.propTypes;
        else
          return;
        if (a) {
          var f = W(r);
          wt(a, e.props, "prop", f, e);
        } else if (r.PropTypes !== void 0 && !Ee) {
          Ee = !0;
          var p = W(r);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Wt(e) {
      {
        for (var r = Object.keys(e.props), a = 0; a < r.length; a++) {
          var f = r[a];
          if (f !== "children" && f !== "key") {
            G(e), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), G(null);
            break;
          }
        }
        e.ref !== null && (G(e), y("Invalid attribute `ref` supplied to `React.Fragment`."), G(null));
      }
    }
    function Je(e, r, a, f, p, b) {
      {
        var h = ht(e);
        if (!h) {
          var v = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (v += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var S = Lt(p);
          S ? v += S : v += ze();
          var w;
          e === null ? w = "null" : me(e) ? w = "array" : e !== void 0 && e.$$typeof === n ? (w = "<" + (W(e.type) || "Unknown") + " />", v = " Did you accidentally export a JSX literal instead of a component?") : w = typeof e, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", w, v);
        }
        var T = It(e, r, a, p, b);
        if (T == null)
          return T;
        if (h) {
          var j = r.children;
          if (j !== void 0)
            if (f)
              if (me(j)) {
                for (var J = 0; J < j.length; J++)
                  Ge(j[J], e);
                Object.freeze && Object.freeze(j);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ge(j, e);
        }
        return e === o ? Wt(T) : At(T), T;
      }
    }
    function Ft(e, r, a) {
      return Je(e, r, a, !0);
    }
    function Mt(e, r, a) {
      return Je(e, r, a, !1);
    }
    var $t = Mt, Nt = Ft;
    ie.Fragment = o, ie.jsx = $t, ie.jsxs = Nt;
  }()), ie;
}
lt.env.NODE_ENV === "production" ? Ce.exports = Zt() : Ce.exports = er();
var D = Ce.exports;
const ft = Bt({
  renderWidget: () => {
  },
  setWidgetConfig: async () => {
  },
  providers: {},
  /** Experimental API below. */
  experimental_expand: () => {
  },
  experimental_destroyWidget: () => {
  }
});
function en({ wallet: t, children: n }) {
  return /* @__PURE__ */ D.jsx(ft.Provider, { value: t, children: n });
}
var tr = "Expected a function", Ze = NaN, rr = "[object Symbol]", nr = /^\s+|\s+$/g, or = /^[-+]0x[0-9a-f]+$/i, ir = /^0b[01]+$/i, ar = /^0o[0-7]+$/i, sr = parseInt, ur = typeof fe == "object" && fe && fe.Object === Object && fe, cr = typeof self == "object" && self && self.Object === Object && self, lr = ur || cr || Function("return this")(), fr = Object.prototype, dr = fr.toString, vr = Math.max, hr = Math.min, _e = function() {
  return lr.Date.now();
};
function pr(t, n, i) {
  var o, s, c, l, u, d, m = 0, g = !1, R = !1, C = !0;
  if (typeof t != "function")
    throw new TypeError(tr);
  n = et(n) || 0, Se(i) && (g = !!i.leading, R = "maxWait" in i, c = R ? vr(et(i.maxWait) || 0, n) : c, C = "trailing" in i ? !!i.trailing : C);
  function x(E) {
    var I = o, U = s;
    return o = s = void 0, m = E, l = t.apply(U, I), l;
  }
  function Y(E) {
    return m = E, u = setTimeout(P, n), g ? x(E) : l;
  }
  function A(E) {
    var I = E - d, U = E - m, te = n - I;
    return R ? hr(te, c - U) : te;
  }
  function B(E) {
    var I = E - d, U = E - m;
    return d === void 0 || I >= n || I < 0 || R && U >= c;
  }
  function P() {
    var E = _e();
    if (B(E))
      return y(E);
    u = setTimeout(P, A(E));
  }
  function y(E) {
    return u = void 0, C && o ? x(E) : (o = s = void 0, l);
  }
  function Z() {
    u !== void 0 && clearTimeout(u), m = 0, o = d = s = u = void 0;
  }
  function ee() {
    return u === void 0 ? l : y(_e());
  }
  function q() {
    var E = _e(), I = B(E);
    if (o = arguments, s = this, d = E, I) {
      if (u === void 0)
        return Y(d);
      if (R)
        return u = setTimeout(P, n), x(d);
    }
    return u === void 0 && (u = setTimeout(P, n)), l;
  }
  return q.cancel = Z, q.flush = ee, q;
}
function Se(t) {
  var n = typeof t;
  return !!t && (n == "object" || n == "function");
}
function gr(t) {
  return !!t && typeof t == "object";
}
function mr(t) {
  return typeof t == "symbol" || gr(t) && dr.call(t) == rr;
}
function et(t) {
  if (typeof t == "number")
    return t;
  if (mr(t))
    return Ze;
  if (Se(t)) {
    var n = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Se(n) ? n + "" : n;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(nr, "");
  var i = ir.test(t);
  return i || ar.test(t) ? sr(t.slice(2), i ? 2 : 8) : or.test(t) ? Ze : +t;
}
var br = pr;
const tt = /* @__PURE__ */ Qt(br);
function yr(t) {
  const n = $(t);
  n.current = t, O(() => () => {
    n.current();
  }, []);
}
function Er(t, n = 500, i) {
  const o = $();
  yr(() => {
    o.current && o.current.cancel();
  });
  const s = ot(() => {
    const c = tt(t, n, i), l = (...u) => c(...u);
    return l.cancel = () => {
      c.cancel();
    }, l.isPending = () => !!o.current, l.flush = () => c.flush(), l;
  }, [t, n, i]);
  return O(() => {
    o.current = tt(t, n, i);
  }, [t, n, i]), s;
}
const Oe = typeof window > "u" ? O : Yt;
function dt(t, n, i, o) {
  const s = $(n);
  Oe(() => {
    s.current = n;
  }, [n]), O(() => {
    const c = (i == null ? void 0 : i.current) ?? window;
    if (!(c && c.addEventListener))
      return;
    const l = (u) => {
      s.current(u);
    };
    return c.addEventListener(t, l, o), () => {
      c.removeEventListener(t, l, o);
    };
  }, [t, i, o]);
}
const wr = typeof window > "u";
function _r(t, { defaultValue: n = !1, initializeWithValue: i = !0 } = {}) {
  const o = (u) => wr ? n : window.matchMedia(u).matches, [s, c] = H(() => i ? o(t) : n);
  function l() {
    c(o(t));
  }
  return Oe(() => {
    const u = window.matchMedia(t);
    return l(), u.addListener ? u.addListener(l) : u.addEventListener("change", l), () => {
      u.removeListener ? u.removeListener(l) : u.removeEventListener("change", l);
    };
  }, [t]), s;
}
function Rr({ ref: t, handler: n, context: i, eventType: o = "mousedown", eventListenerOptions: s = {} }) {
  dt(o, (c) => {
    const l = c.target;
    if (!l || !l.isConnected)
      return;
    const u = Array.isArray(t) ? t.filter((g) => !!g.current).every((g) => g.current && !g.current.contains(l)) : t.current && !t.current.contains(l), d = document.querySelectorAll(`[data-click-outside-context="${i}"]`), m = Array.from(d).some((g) => g.contains(l));
    u && !m && n(c);
  }, void 0, s);
}
const Tr = typeof window > "u";
function Cr(t = {}) {
  let { initializeWithValue: n = !0 } = t;
  Tr && (n = !1);
  const [i, o] = H(() => n ? {
    width: window.innerWidth,
    height: window.innerHeight
  } : {
    width: void 0,
    height: void 0
  }), s = Er(o, t.debounceDelay);
  function c() {
    (t.debounceDelay ? s : o)({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }
  return dt("resize", c), Oe(() => {
    c();
  }, []), i;
}
const Sr = 8, Or = {
  small: 8,
  medium: 10,
  large: 12
}, xr = {
  width: 32,
  height: 32
}, Pr = {
  small: { width: 144, height: 32 },
  medium: { width: 148, height: 36 },
  large: { width: 152, height: 40 },
  huge: { width: 232, height: 64 }
}, jr = 32, ve = { width: 400, height: 672 }, Dr = {
  width: "100vw",
  height: "100dvh"
};
function Ir(t) {
  const n = $(null), i = (s) => {
    n.current = s.style.overflow, s.style.overflow = "hidden";
  }, o = (s) => {
    s.style.overflow = n.current, n.current = null;
  };
  O(() => {
    const s = document.body;
    s && (t ? i(s) : o(s));
  }, [t]), O(() => {
    const s = document.body;
    if (s)
      return () => {
        o(s);
      };
  }, []);
}
function Lr() {
  const [t, n] = H(!1);
  return O(() => {
    const i = (o) => {
      var s;
      if (((s = o.data) == null ? void 0 : s.type) === "wallet:resize") {
        const { expanded: c } = o.data;
        n(c);
      }
    };
    return window.addEventListener("message", i), () => {
      window.removeEventListener("message", i);
    };
  }, []), [t, n];
}
const X = 20, kr = ({
  wrapperBoundingBox: t,
  windowDimensions: n,
  targetDimensions: i
}) => {
  const { left: o, right: s, width: c } = t, { width: l } = n, { width: u } = i, d = (u - c) / 2;
  return o - d - X > 0 && s + d + X < l ? { left: -d } : s - u - X > 0 ? { right: 0 } : o + u + X < l ? { left: 0 } : { left: (l - u) / 2 - o };
}, Ar = ({
  wrapperBoundingBox: t,
  windowDimensions: n,
  targetDimensions: i
}) => {
  const { top: o, bottom: s, height: c } = t, { height: l } = n, { height: u } = i;
  return o + u + X < l ? { top: 0 } : s - u - X > 0 ? { top: -u + c } : { top: -(o - 20) };
}, Wr = ({
  wrapperBoundingBox: t,
  windowDimensions: n,
  targetDimensions: i
}) => {
  const o = kr({
    wrapperBoundingBox: t,
    windowDimensions: n,
    targetDimensions: i
  }), s = Ar({
    wrapperBoundingBox: t,
    windowDimensions: n,
    targetDimensions: i
  });
  return {
    ...o,
    ...s
  };
}, Fr = ({ ref: t, dimensions: n, expanded: i }) => {
  const o = $(), s = Cr();
  return ot(() => {
    if (!t.current || !i) {
      const { right: d, left: m } = o.current ?? { left: 0 };
      return {
        top: 0,
        right: d === void 0 ? void 0 : 0,
        left: m === void 0 ? void 0 : 0
      };
    }
    const c = t.current.getBoundingClientRect(), u = Wr({
      wrapperBoundingBox: c,
      windowDimensions: s,
      targetDimensions: n
    });
    return o.current = u, u;
  }, [t, i, n, s]);
};
function Mr({
  className: t,
  collapsedBorderRadius: n,
  collapsedDimensions: i,
  expanded: o,
  fullScreen: s,
  style: c
}, l) {
  const u = $(null), d = o ? s ? 0 : `${jr}px` : `${n}px`, m = o ? s ? Dr : ve : i, g = Fr({
    ref: u,
    dimensions: ve,
    expanded: o
  }), [R, C] = H(!1);
  return O(() => {
    C(!0);
    const x = setTimeout(() => C(!1), 200);
    return () => {
      clearTimeout(x);
    };
  }, [o]), /* @__PURE__ */ D.jsx(
    "div",
    {
      className: t,
      ref: u,
      style: {
        ...c,
        position: "relative",
        width: i.width,
        height: i.height
      },
      children: /* @__PURE__ */ D.jsx(
        "div",
        {
          style: {
            position: o && s ? "fixed" : "absolute",
            ...s ? { inset: 0 } : g,
            zIndex: !o && !R ? "auto" : 1e3,
            width: m.width,
            height: m.height,
            borderRadius: d,
            overflow: "hidden",
            boxShadow: o ? "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 32px 64px -12px rgba(16, 24, 40, 0.14)" : "none",
            transition: "top ease-out 300ms, left ease-out 300ms, right ease-out 300ms, width ease-out 300ms, height ease-out 300ms, border-radius ease-out 300ms"
          },
          ref: l
        }
      )
    }
  );
}
const $r = it(Mr);
function Q() {
  const t = Ut(ft);
  if (t === void 0)
    throw new Error("useWallet must be used within a WalletProvider");
  return t;
}
const Nr = ({
  autoCollapse: t,
  className: n,
  collapsedBorderRadius: i,
  collapsedDimensions: o,
  opened: s,
  smallScreen: c,
  style: l,
  onClose: u
}) => {
  const { renderWidget: d } = Q(), m = $(null);
  return O(() => {
    d(m.current);
  }, [d]), Rr({
    ref: m,
    handler: () => {
      t && u();
    },
    context: "wallet-widget"
  }), /* @__PURE__ */ D.jsx(
    $r,
    {
      className: n,
      collapsedBorderRadius: i,
      collapsedDimensions: o,
      expanded: s,
      fullScreen: c,
      ref: m,
      style: l
    }
  );
}, vt = 300;
function Br(t, n) {
  return /* @__PURE__ */ D.jsx(
    "div",
    {
      ref: n,
      style: {
        width: ve.width,
        height: ve.height,
        borderRadius: 10,
        overflow: "hidden",
        position: "relative"
      }
    }
  );
}
const Yr = it(Br);
function Ur({ children: t, visible: n, onClick: i }) {
  return /* @__PURE__ */ D.jsx(
    "div",
    {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.4)",
        opacity: n ? 1 : 0,
        pointerEvents: n ? "auto" : "none",
        transition: `opacity ${vt}ms`
      },
      onClick: i,
      children: t
    }
  );
}
const Vr = ({
  className: t,
  collapsedDimensions: n,
  collapsedBorderRadius: i,
  opened: o,
  style: s,
  theme: c,
  onClose: l
}) => {
  const { renderWidget: u } = Q(), d = $(null), m = $(null);
  return O(() => {
    const g = o ? m : d;
    setTimeout(() => u(g.current), vt);
  }, [o, u]), /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    /* @__PURE__ */ D.jsx(
      "div",
      {
        ref: d,
        className: t,
        style: {
          ...s,
          ...n,
          overflow: "hidden",
          borderRadius: i
        }
      }
    ),
    zt(
      /* @__PURE__ */ D.jsx(Ur, { visible: o, onClick: l, children: /* @__PURE__ */ D.jsx(Yr, { theme: c, ref: m }) }),
      document.body
    )
  ] });
};
function zr() {
  const t = Q(), [n, i] = H(!1), o = t.providers.bitcoin;
  return O(() => {
    if (!o)
      return;
    o.isConnected().then((l) => i(l));
    const s = () => i(!0), c = () => i(!1);
    return o.on("connect", s), o.on("disconnect", c), () => {
      o.removeListener("connect", s), o.removeListener("disconnect", c);
    };
  }, [o]), n;
}
function Hr() {
  const t = Q(), [n, i] = H([]), o = t.providers.ethereum;
  return O(() => {
    if (!o)
      return;
    o.request({ method: "eth_accounts" }).then((c) => i(c));
    const s = (c) => i(c);
    return o.on("accountsChanged", s), () => {
      o.removeListener("accountsChanged", s);
    };
  }, [o]), n.length > 0;
}
function qr() {
  const t = Q(), [n, i] = H(!1), o = t.providers.solana;
  return O(() => {
    if (!o)
      return;
    o.request({ method: "isConnected", params: [] }).then((l) => i(l));
    const s = () => i(!0), c = () => i(!1);
    return o.on("connect", s), o.on("disconnect", c), () => {
      o.removeListener("connect", s), o.removeListener("disconnect", c);
    };
  }, [o]), n;
}
function Gr() {
  const t = Hr(), n = zr(), i = qr();
  return t || n || i;
}
const Jr = 540, Xr = (t) => `(max-width: ${t}px)`, Kr = {
  variant: "glow",
  colors: {
    collapsed: {}
  }
}, rt = {
  dropdown: Nr,
  modal: Vr
};
function tn({
  theme: t = Kr,
  size: n = "medium",
  shape: i = "rounded",
  experimental_mode: o = "dropdown",
  noAutoCollapse: s = !1,
  compact: c = !1,
  noAutoCompact: l = !1,
  smallBreakpoint: u = Jr,
  className: d,
  style: m
}) {
  const g = Gr(), [R, C] = Lr(), { renderWidget: x, setWidgetConfig: Y } = Q(), A = _r(Xr(u)), B = c || A && !l;
  Ir(A && R), O(() => () => {
    x(null);
  }, [x]), O(() => {
    Y({
      theme: t,
      size: n,
      shape: i,
      compact: c,
      noAutoCompact: l,
      smallScreen: A
    });
  }, [
    t,
    n,
    i,
    B,
    l,
    A,
    Y,
    c
  ]);
  const P = Vt(() => {
    C(!1);
  }, [C]);
  if (!g)
    return null;
  const y = B ? xr : Pr[n], Z = i === "rounded" ? y.height / 2 : B ? Sr : Or[n], ee = rt[o] || rt.dropdown;
  return /* @__PURE__ */ D.jsx(
    ee,
    {
      autoCollapse: !s,
      className: d,
      collapsedBorderRadius: Z,
      collapsedDimensions: y,
      opened: R,
      smallScreen: A,
      theme: t,
      style: m,
      onClose: P
    }
  );
}
Ht && Object.defineProperty(window, "__passkeys-react-version__", {
  value: qt,
  writable: !1,
  enumerable: !1
});
export {
  en as WalletProvider,
  tn as WalletWidget,
  Q as useWallet
};
